import { Button, Card } from '@payaca/ambrosia';
import { currencyPrice } from '@payaca/helpers/financeHelper';
import { getAccountRegionFromCurrencyCodeLegacy } from '@payaca/helpers/internationalHelper';
import { AccountsPermissions } from '@payaca/permissions/accounts/accounts.permissions';
import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import { Nullish } from '@payaca/utilities/types';
import { FC, useState } from 'react';
import { useParams } from 'react-router';
import { useGetUser } from '../../../../api/queries/user/useGetUser';
import { PermissionGuard } from '../../../components/permissionGuard/PermissionGuard';
import { UpdateUserModal } from '../../../components/updateUserModal/UpdateUserModal';

const UserProfile: FC = () => {
  const { userId } = useParams<{ userId: string }>();
  const { data: userData, refetch: refetchUser } = useGetUser(+userId);
  const user = userData?.user;
  const region =
    user?.costPerHour?.currency &&
    getAccountRegionFromCurrencyCodeLegacy(
      user?.costPerHour?.currency.code || 'gbp'
    );

  const [showUpdateUserProfileModal, setShowUpdateUserProfileModal] =
    useState(false);
  return (
    <>
      <Card>
        <Card.Body>
          <div className="flex justify-between">
            <h3>About</h3>
            <PermissionGuard
              renderIfHasPermissions={[
                AccountsPermissions.SET_USER_COLOUR,
                AccountsPermissions.SET_USER_COST_PER_HOUR,
                AccountsPermissions.UPDATE_ROLE,
              ]}
            >
              <Button onClick={() => setShowUpdateUserProfileModal(true)}>
                Edit
              </Button>
            </PermissionGuard>
          </div>
          <div className="mt-2 flex flex-col gap-y-2">
            <UserProperty iconName="key-01.3" value={user?.systemRole} />
            <UserProperty iconName="mail-02.3" value={user?.email} />
            <UserProperty iconName="phone.3" value={user?.phone} />
            <PermissionGuard
              renderIfHasPermissions={[
                AccountsPermissions.GET_USER_COST_PER_HOUR,
              ]}
            >
              <UserProperty
                iconName="currency-pound"
                value={
                  user?.costPerHour?.value &&
                  `${currencyPrice(user?.costPerHour?.value, region)}/hr`
                }
              />
            </PermissionGuard>
          </div>
        </Card.Body>
      </Card>
      <UpdateUserModal
        userId={+userId}
        isOpen={showUpdateUserProfileModal}
        onClose={() => setShowUpdateUserProfileModal(false)}
        onSuccess={() => {
          void refetchUser();
          setShowUpdateUserProfileModal(false);
        }}
      />
    </>
  );
};

type UserPropertyProps = {
  iconName: TIconName;
  value?: Nullish<string | number>;
};
const UserProperty: FC<UserPropertyProps> = ({ iconName, value }) => {
  if (!value) {
    return null;
  }
  return (
    <div className="flex gap-x-3 items-center">
      <UntitledIcon name={iconName} className="h-4 w-4 text-blue-900" />
      <span>{value}</span>
    </div>
  );
};

export default UserProfile;
